import { hasRole, Role } from '../utils/user';

export function canManageBlock() {
  return hasRole([Role.admin, Role.editor]) || window.userHasAdvancedEditorAccess;
}
